module.exports = __webpack_public_path__ + "static/media/aag.3f5186d7.png";